<template>
  <v-card variant="flat" class="pa-4 app-content-card">
    <div class="text-subtitle-1 ncrm-text-strong">
      {{ $t("ncrm.deals.board.settings.rules.title") }}
    </div>
    <div class="text-body-2 text-medium-emphasis mt-1">
      {{ $t("ncrm.deals.board.settings.rules.description") }}
    </div>

    <v-alert
      v-if="feedback"
      :type="feedbackColor"
      density="comfortable"
      class="mt-3"
    >
      {{ feedback }}
    </v-alert>

    <v-switch
      :model-value="form.autoCreateTaskIfMissingAfterChange"
      color="primary"
      hide-details
      class="mt-3"
      :label="$t('ncrm.deals.board.settings.rules.autoCreateTaskIfMissingAfterChange')"
      @update:model-value="updateField('autoCreateTaskIfMissingAfterChange', $event)"
    />

    <v-switch
      :model-value="form.autoCreateTaskIfMissingProduct"
      color="primary"
      hide-details
      class="mt-2"
      :label="$t('ncrm.deals.board.settings.rules.autoCreateTaskIfMissingProduct')"
      @update:model-value="updateField('autoCreateTaskIfMissingProduct', $event)"
    />

    <v-text-field
      :model-value="form.autoCreateTaskIfMissingDelayMinutes"
      class="mt-3"
      type="number"
      min="1"
      max="10080"
      step="1"
      hide-details
      :disabled="delayDisabled"
      :label="$t('ncrm.deals.board.settings.rules.autoCreateTaskIfMissingDelayMinutes')"
      @update:model-value="updateField('autoCreateTaskIfMissingDelayMinutes', $event)"
    />

    <div class="text-caption text-medium-emphasis mt-1">
      {{ $t("ncrm.deals.board.settings.rules.help") }}
    </div>

    <div class="d-flex justify-end mt-4">
      <v-btn color="primary" :loading="loading" :disabled="loading" @click="$emit('save')">
        {{ $t("app.actions.save") }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "NcrmDealBoardRulesSettings",
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    feedback: {
      type: String,
      default: "",
    },
    feedbackColor: {
      type: String,
      default: "success",
    },
  },
  emits: ["update:modelValue", "clear-feedback", "save"],
  computed: {
    form() {
      return this.modelValue || {};
    },
    delayDisabled() {
      return !this.form.autoCreateTaskIfMissingAfterChange && !this.form.autoCreateTaskIfMissingProduct;
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit("clear-feedback");
      this.$emit("update:modelValue", {
        ...this.form,
        [field]: value,
      });
    },
  },
};
</script>
